module.exports = __webpack_public_path__ + "static/media/bg20.8bf0049a.jpg";